/* eslint-disable @typescript-eslint/member-ordering */
import { Injectable, signal } from '@angular/core';

import { ErrorInfo } from '../../features/error/error-page.component';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  private readonly _currentError = signal<ErrorInfo | null>(null);
  readonly currentError = this._currentError.asReadonly();

  setError(error: ErrorInfo): void {
    this._currentError.set(error);
  }

  clearError(): void {
    this._currentError.set(null);
  }
}
